import { call, put, all } from "redux-saga/effects"
import api from "../../../data/api";
import { Currency, CurrencyResponse, CurrencyResponseResultEnum } from "../../../openapi/currency/api"
import { OptionCl } from "../../../components/select-cl"
import { AxiosResponse } from "axios";
import { prepareError } from "../../../utils/error"
import { DepositoryResponse, DepositoryResponseResultEnum, Depository } from "../../../openapi/depository";

export function* fetchSecurityDomains() {
    console.log("Fetchsecuritydomains: call")
    yield put({ type: "SecurityCriteria/DOMAINLOADREQUESTED" }) // shows Loading... in criteria
    // execute in parallel
    yield all([
        call(fetchNominalCurrencies),
        call(fetchSecurityPhysicalForms),
        call(fetchInstrumentCategories),
        call(fetchCffQualified),
        call(fetchPrincipalTransferAgent),    
        call(fetchIsinPerCtry),
        call(fetchCsdOfIssuance),
        call(fetchIsmagAdherence),    
        call(fetchFatca),
        call(fetchCtryOfTax),
        call(fetchTaxSpecificity),
        call(fetchCbfCustodyType)
    ])
}

/*******************************************************************************************************************************/
export const NOMINALCURRENCY_DOMAIN = "NOMINALCURRENCY"

const nominalCurrencyDomain: OptionCl[] = [
    { id: "EUR", description: "EUR - EURO" },
    { id: "GBP", description: "GBP - POUND STERLING" },
    { id: "ISK", description: "ISK - ICELAND KRONA" },
    { id: "USD", description: "USD - US DOLLAR" }]

function* fetchNominalCurrencies() {
    yield put({ type: "SecurityCriteria/DOMAINLOADED", payload: nominalCurrencyDomain, domain: NOMINALCURRENCY_DOMAIN })
}

/*******************************************************************************************************************************/
export const SECURITY_PHYSICAL_FORM = "SECUPHYSFORMDOMAIN"

const secuFormDomain: OptionCl[] = [
    { id: "ANY EXCLUDING NGN", description: "ANY EXCLUDING NGN" },
    { id: "COMGLOB", description: "COMMON GLOBAL" },
    { id: "CSGLOB", description: "CS GLOBAL" },
    { id: "DEF", description: "DEFINITIVE" },
    { id: "DEMAT", description: "DEMATERIALIZED" },
    { id: "EBGLOB", description: "EB GLOBAL" },
    { id: "GLOB", description: "GLOBAL" },
    { id: "NGN", description: "NGN" },
    { id: "TEMPGLOB", description: "TEMPORARY GLOBAL" },
    { id: "TRANSIT", description: "TRANSIT" }]

function* fetchSecurityPhysicalForms() {
    yield put({ type: "SecurityCriteria/DOMAINLOADED", payload: secuFormDomain, domain: SECURITY_PHYSICAL_FORM })
}

/*******************************************************************************************************************************/
export const INSTRUMENT_CATEGORY_DOMAIN = "INSTRUMENT_CATEGORY_DOM"

const instCatDomain: OptionCl[] =
    ["DEBT", "EQUITY", "FUTURE", "OTHER", "PROGRAM", "RIGHT", "UNIT", "WARRANT"]
        .map((item) => ({ id: item, description: item }))

function* fetchInstrumentCategories() {
    yield put({ type: "SecurityCriteria/DOMAINLOADED", payload: instCatDomain, domain: INSTRUMENT_CATEGORY_DOMAIN })
}

/*******************************************************************************************************************************/
export const CFFFLAG_DOMAIN = "CFF_QUALIFIED_DOMAIN"

const cffFlagDomain: OptionCl[] =
    ["Yes", "No"]
        .map((item) => ({ id: item, description: item }))

function* fetchCffQualified() {
    yield put({ type: "SecurityCriteria/DOMAINLOADED", payload: cffFlagDomain, domain: CFFFLAG_DOMAIN })
}

/*******************************************************************************************************************************/
export const PRINCIPAL_TRANSFER_AGENT = "PRINCIPAL_TRANSFER_AGENT_DOMAIN"

const principalTraansferAAgentyDomain: OptionCl[] = [
    { id: "1ICOMMON", description: "1I - ISD" },
    { id: "L9COMMON", description: "L9 - LUXCSD / BIL SA" },
    { id: "YNCOMMON", description: "YN - CRDT SUISSE FS LU" }    
]

function* fetchPrincipalTransferAgent() {
    yield put({ type: "SecurityCriteria/DOMAINLOADED", payload: principalTraansferAAgentyDomain, domain: PRINCIPAL_TRANSFER_AGENT })
}
/*******************************************************************************************************************************/
export const ISIN_PER_CTRY_DOMAIN = "ISIN_PER_CTRY_DOMAIN"

const isinPerCtryDomain: OptionCl[] = [
    { id: "IE", description: "IE - IRELAND" },
    { id: "IS", description: "IS - ICELAND" },
    { id: "LU", description: "LU - LUXEMBOURG" },
    { id: "NL", description: "NL - NETHERLANDS" },
    { id: "QT", description: "QT - INTERNATIONAL ALTERNATIVE INVESTMENTS" },
    { id: "QX", description: "QX - INTERNATIONAL ALTERNATIVE INVESTMENTS" }
]

function* fetchIsinPerCtry() {
    yield put({ type: "SecurityCriteria/DOMAINLOADED", payload: isinPerCtryDomain, domain: ISIN_PER_CTRY_DOMAIN })
}
/*******************************************************************************************************************************/
export const CSD_OF_ISSUANCE_DOMAIN = "CSD_OF_ISSUANCE_DOMAIN";

const csdOfIssuanceDomain: OptionCl[] =
    ["LUXCLULLXXX"]
        .map((item) => ({ id: item, description: item }))

function* fetchCsdOfIssuance() {
    yield put({ type: "SecurityCriteria/DOMAINLOADED", payload: csdOfIssuanceDomain, domain: CSD_OF_ISSUANCE_DOMAIN })
}

/*******************************************************************************************************************************/
export const ISMAG_ADHERENCE_DOMAIN = "ISMAG_ADHERENCE_DOMAIN";

const ismagAdherenceDomain: OptionCl[] =
    ["NONE"]
        .map((item) => ({ id: item, description: item }))

function* fetchIsmagAdherence() {
    yield put({ type: "SecurityCriteria/DOMAINLOADED", payload: ismagAdherenceDomain, domain: ISMAG_ADHERENCE_DOMAIN })
}

/*******************************************************************************************************************************/
export const COUNTRY_OF_TAX_DOMAIN = "COUNTRY_OF_TAX_DOMAIN";

const ctrOfTaxyDomain: OptionCl[] = [    
    { id: "IS", description: "IS - ICELAND" },
    { id: "LU", description: "LU - LUXEMBOURG" },
    { id: "NL", description: "NL - NETHERLANDS" }
]

function* fetchCtryOfTax() {
    yield put({ type: "SecurityCriteria/DOMAINLOADED", payload: ctrOfTaxyDomain, domain: COUNTRY_OF_TAX_DOMAIN })
}

/*******************************************************************************************************************************/
export const FATCA_DOMAIN = "FATCA_DOMAIN";

const fatcaDomain: OptionCl[] =
    ["ALL", "YES", "NO"]
        .map((item) => ({ id: item, description: item }))

function* fetchFatca() {
    yield put({ type: "SecurityCriteria/DOMAINLOADED", payload: fatcaDomain, domain: FATCA_DOMAIN })
}

/*******************************************************************************************************************************/
export const TAX_SPECIFICITY_DOMAIN = "TAX_SPECIFICITY_DOMAIN"

const taxSpecificityDomain: OptionCl[] = 
[{ id: "BLOCK", description: "SECURITY TAXABLE BUT FOR WHICH NO AUTOMATIC NOTIFICATION IS SENT"}]

function* fetchTaxSpecificity() {
    yield put({ type: "SecurityCriteria/DOMAINLOADED", payload: taxSpecificityDomain, domain: TAX_SPECIFICITY_DOMAIN })
}
/*******************************************************************************************************************************/
export const CBF_CUSTODY_TYPE_DOMAIN = "CBF_CUSTODY_TYPE_DOMAIN";

const cbfCustodyTypeDomain: OptionCl[] =
    ["CSC", "NCSC", "NCSC-T"]
        .map((item) => ({ id: item, description: item }))

function* fetchCbfCustodyType() {
    yield put({ type: "SecurityCriteria/DOMAINLOADED", payload: cbfCustodyTypeDomain, domain: CBF_CUSTODY_TYPE_DOMAIN })
}


